<template>
  <div class="sn-f-col-b-s area">
    <div class="sn-f-s-0 sn-f-b-e" style="width: 100%;">
      <sn-breadcrumb :breadcrumb="[{
        title: $sn.utils.getFunctionTitle('0', perpetual.FUNCTION_ID_GHYY),
      }]"></sn-breadcrumb>
      <div class="sn-f-e-c sn-search">
        <input placeholder="搜索医生、科室、疾病" v-model="dynamic" @keyup.enter="navigateUrl('/appointment/search', '', {
          dynamic: dynamic ? encodeURIComponent(dynamic) : ''
        });"/>
        <div class="sn-f-c-c interaction" @click="navigateUrl('/appointment/search', '', {
          dynamic: dynamic ? encodeURIComponent(dynamic) : ''
        });">查询</div>
      </div>
    </div>
    <div class="sn-f-1 area-region" :style="background">
      <div class="area-blank" :key="area.areaId" v-for="area in areaList">
        <div class="sn-f-b-e sn-title">
          <div class="sn-f-c-c title-caption">{{ area.areaName }}</div>
        </div>
        <div class="sn-f-b-s area-info">
          <div class="area-header">
            <img :src="area.photo">
            <div class="area-title">{{ area.areaName }}</div>
            <div class="area-address">{{ area.address }}</div>
          </div>
          <div class="sn-f-1 sn-f-s-c sn-f-wrap">
            <div class="sn-f-col-c-c sn-pointer area-business" :key="business.type" v-for="business in area.business" @click="goBusiness(area, business);">
              <div class="label"></div>
              <div class="sn-fs-22">{{ business.title }}</div>
              <div class="sub" v-if="business.caption" v-html="business.caption"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import { businessConfig } from '@/common/utils/function-config.js';
import self from '@/common/utils/global-config';
import Swagger from '@/common/utils/swagger';
import HomepageMixin from '@/common/mixin/homepage-mixin';

export default {
  mixins: [HomepageMixin],
  data() {
    return {
      ALI_CLOUD_DOMAIN_STATIC: self.$sn.constants.ALI_CLOUD_DOMAIN_STATIC,
      dynamic: '',
      areaList: self.$sn.utils.getHospitalAreaInformation()
    };
  },
  computed: {
    background() {
      const pattern = {};
      if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_SDQL) {
        this.$set(pattern, 'background-image', `url(${this.$sn.constants.ALI_CLOUD_DOMAIN_STATIC}/ql/images/a9347462-32d9-4f93-aaef-1096dad113d3.png)`);
        this.$set(pattern, 'background-position', 'bottom right');
        this.$set(pattern, 'background-repeat', 'no-repeat');
      }
      return pattern;
    }
  },
  created: async function() {
    if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_SDQL) {
      this.areaList[0].areaName = '中心院区';
      this.$sn.assembly.loading(true);
      const area = await new Promise(resolve => {
        this.$sn.utils.ordinaryRequest({
          url: Swagger.getHospitalAreaInformation,
          query: {
            hosId: this.perpetual.HOSPITAL_ID_QDQL
          }
        }).then(result => {
          if (result && result.code === 0 && result.data && result.data.length > 0) resolve(result.data[0]);
          else resolve({});
        }).catch(() => {
          resolve({});
        });
      });
      this.$sn.assembly.loading(false);
      if (area.areaId) {
        area.areaId = area.hosId;
        area.areaName = '青岛院区';
        area.photo = this.ALI_CLOUD_DOMAIN_STATIC + '/ql/images/3ea9dcdc-47cf-4055-8da7-5817a91782c4.jpg';
        area.sort = 2;
        this.areaList.push(area);
      }
    }
    this.formatFunctionConfig();
  },
  methods: {
    formatFunctionConfig() {
      const func = [];
      const business = businessConfig();
      if (!this.$sn.validate.empty(this.$sn.getConfig('areaOrdinaryFunctionType'))) {
        this.$sn.getConfig('areaOrdinaryFunctionType').forEach(type => {
          const match = this.$sn.format.clone(business).find(result => result.type === type);
          if (!this.$sn.validate.empty(match)) {
            func.push(match);
          }
        });
      }
      this.areaList.forEach(area => {
        this.$set(area, 'business', this.$sn.format.clone(func));
        if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_SDSL) {
          if (area.areaId === '2') {
            const match = this.$sn.format.clone(business).find(result => result.type === this.perpetual.BASIC_BUSINESS_OFFLINE_GJTXMZ);
            if (!this.$sn.validate.empty(match)) {
              area.business.push(match);
            }
          }
        }
        else if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_SDQL) {
          if (area.areaId === this.perpetual.HOSPITAL_ID_QDQL) {
            area.business = [{
              caption: '',
              image: '',
              params: {
                title: '就诊服务',
                caption: '您即将预约山东大学齐鲁医院青岛院区门诊号源，需要前往青岛院区就诊。' +
                '就诊地点：青岛市市北区合肥路758号。' +
                `<img style="display: block; width: 80%; height: auto; margin: 0 auto;" src="${this.ALI_CLOUD_DOMAIN_STATIC}/ql/images/fd1b6a63-7fc4-42ba-86d5-28ddbc941a0c.jpg">`,
                isCancel: false
              },
              remark: '',
              sort: 0,
              title: '预约挂号',
              type: this.perpetual.FUNCTION_ID_GHYY,
              url: 'modal'
            }];
          }
        }
        area.business = this.$sn.format.digitalSort(area.business);
      });
    },
    goBusiness(area, business) {
      this.$sn.utils.setHospitalSessionStorage('AppointmentArea', area);
      if (business.url) {
        this.navigateUrl(business.url, business, business.params);
        return false;
      }
      this.$sn.utils.setHospitalSessionStorage('AppointmentType', business.type);
      this.navigateUrl('/appointment/depart');
    },
    navigateUrl(url, item, params, type = 'push') {
      if (this.$sn.validate.empty(url)) return false;
      if (url === 'modal') {
        this.$sn.assembly.modal(params);
      }
      else {
        this.homepage_mixin_navigateUrl(url, item, params, type);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.area {
  overflow: hidden;
  width: 100%;
  height: 100%;

  &-region {
    overflow-x: hidden;
    overflow-y: auto;
    width: 100%;

    .area-blank {
      overflow: hidden;
      width: 100%;
      padding: 0 20px;
      margin-bottom: 20px;

      &:first-child {
        margin-top: 20px;
      }

      .area-info {
        overflow: hidden;
        width: 100%;
        padding: 20px 20px 0;

        .area-header {
          overflow: hidden;
          width: 240px;
          background-color: $background2;
          border: 1px solid $border1;
          border-radius: 8px;
          padding: 20px 20px 40px;
          margin-right: 80px;

          img {
            width: 100%;
            height: auto;
          }

          .area-title {
            @include fs(24);

            overflow: hidden;
            width: 100%;
            color: $main;
            text-align: center;
            border-bottom: 1px solid $border1;
            padding: 10px 0;
          }

          .area-address {
            @include fs(16);

            overflow: hidden;
            width: 100%;
            color: $text3;
            text-align: center;
            padding-top: 10px;
          }
        }

        .area-business {
          width: 280px;
          height: 100px;
          background-color: $main1;
          color: $white;
          padding: 10px;
          margin: 20px 160px 20px 0;
          position: relative;

          &:nth-child(2n+2) {
            margin-right: 0;
          }

          &::before,
          &::after {
            content: '';
            width: 280px;
            height: 1px;
            background-color: $white;
            position: absolute;
            right: 0;
            left: 0;
          }

          &::before {
            top: 3px;
          }

          &::after {
            bottom: 3px;
          }

          .label {
            width: 10px;
            height: 10px;
            background-color: $white;
            border-radius: 50%;
            box-shadow: 0 0 10px $black;
            position: absolute;
            top: 9px;
            left: 6px;
          }

          .sub {
            @include fs(14);

            margin-top: 4px;
          }
        }
      }
    }
  }
}
</style>
